export default __webpack_public_path__ + "static/media/bg2.a6fd2120.jpg";